export const generateAlt = (type = "collection", heading) => {
  let prefix = "";
  switch (type) {
    case "collection":
      prefix = "A collection of";
      break;
  }
  return `${prefix} ${heading}, showing last 4 product images`;
};
